import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {
  addToCart,
  changeActivePartRelatedItemIndex,
  setQtActiveCategory
} from "../../../../../actions/actionFunctions";
import PropTypes from "prop-types";
import {getCurrentLayout} from "../../../../appLayout";
import {
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomId,
  setSQFTActiveRoomType
} from "../../../../../actions/sqftMenuFunctions";
import {getRoomName, getStringFeatureName} from "../../../../../misc/helpers";
import {setActiveQuoteIndex, setQuotes} from "../../../../../actions/roomsFunctions";
import {getNavItems, onSQFTLoadImport, onSQFTLoadPrepareData} from "../../../helpers/sqftHelperUi";
import workspace from "../../canvas/core/workspace";
import {ACTIVE_ROOM_TYPE} from "../../../../../reducers/sqftMenuReducer";
import {injectIntl} from "react-intl";
import {clearAllMenusEvents} from "../../canvas/core/workspace/workspaceEvents";
import FeatureName from "../../../../visComponents/featureName";
import {setNewActiveQuote} from "../../../../../misc/quotesFunctions";
import {shouldSwitchVisualizer, switchToNewVisualizerType} from "../../../../../misc/visualizerSwitchingFunctions";
import {
  getCurrentQuoteRoomCartItem, getRoomCartItemForCategoryName, getRoomNameToCompare, getCurrentQuoteRoomName,
} from "../../../../../misc/categorySwitchingFunctions";
import {getCommonVisualizerType} from "../../../../../config";
import {setSqftFromFeature} from "../../../../../actions/sqftFunctions";
import {saveSQFTDataToQuote} from "../../../helpers/sqftQuotesHelper";

const QuotesSwitcherListRoomGroups = (props) => {
  const {visualizersLoadedLength, activeRoomIndex, cartItems, setSQFTActiveRoomIndex, quotes, setActiveQuoteIndex,
    setSQFTActiveRoomId, setSQFTActiveRoomType, fabricatorData, intl, activeQuoteIndex, addToCart,
    setSqftFromFeature} = props;
  const {startIndex, baseClass, handleDropDownClick} = props
  const [roomGroups, setRoomGroups] = useState(null);
  const layout = getCurrentLayout();

  useEffect(() => {
    if (visualizersLoadedLength.length) {
      const layout = getCurrentLayout();
      const roomsFeatureGroup = layout.getSubPartFromQtCategories('room');
      const roomsNavItems = getNavItems(roomsFeatureGroup, "", false, true);

      if (roomsNavItems) {
        let roomsNavItemsFiltered = roomsNavItems.filter(roomNavItem => {
          const isMatchingWithQuote = quotes.some((quote, quoteIndex) => {
            const roomName = getRoomName(quoteIndex, cartItems, quotes, intl.messages, intl.locale, fabricatorData);
            const roomNavItemPartName = getStringFeatureName(roomNavItem.part, intl.messages, intl.locale, fabricatorData);
            return roomName.includes(roomNavItemPartName) && quote.isVisibleInSQFT !== false
          })
          return !isMatchingWithQuote;
        })
        setRoomGroups(roomsNavItemsFiltered);
      }
    }

  }, [quotes, cartItems, fabricatorData, visualizersLoadedLength, intl, layout])

  const handleCategoryClick = async (roomGroup, roomIndex) => {
    handleDropDownClick();
    clearAllMenusEvents();
    await saveSQFTDataToQuote();
    const nextRoomGroupName = roomGroup.part.getFeatureName().toLowerCase();
    const existingQuoteIndex = quotes.findIndex((quote, quoteIndex) => {
      return (quote.qtCatName === nextRoomGroupName) || (
        getCurrentQuoteRoomName(cartItems, quoteIndex, true) === nextRoomGroupName
      );
    });
    if (existingQuoteIndex > -1) {
      setActiveQuoteIndex(existingQuoteIndex);
      await setNewActiveQuote(existingQuoteIndex, quotes);
      loadQuoteToSQFT();
    } else {
      workspace.import({});
      const newVisualizer = shouldSwitchVisualizer(null, getRoomNameToCompare(roomGroup.part), fabricatorData.settings, false);
      if (newVisualizer) {
        let roomCartItem = getCurrentQuoteRoomCartItem(cartItems, activeQuoteIndex);
        if (!roomCartItem && roomGroup.part.getParent().features) {
          roomCartItem = getRoomCartItemForCategoryName(getCommonVisualizerType(document.kvConfig.visualizerType), fabricatorData.settings);
          if (roomCartItem) {
            roomCartItem.currentQuote = activeQuoteIndex;
            addToCart([roomCartItem]);
          }
        }
        // now we are done with the current quote, let's change visualizer and create a new one
        await switchToNewVisualizerType(newVisualizer);
        // await createNewQuoteAfterVisualizerChange(newVisualizer); // we create new quote only after somethis is added to sqft, so this line is not needed here
      }
    }
    setSqftFromFeature(null);
    setSQFTActiveRoomId(roomGroup.part.getFeatureName().toLowerCase());
    setSQFTActiveRoomIndex(roomIndex);
    setSQFTActiveRoomType(ACTIVE_ROOM_TYPE.roomGroup);
    //setSQFTActiveRoom(qtCategory);
  };

  const loadQuoteToSQFT = () => {
    let payload = onSQFTLoadPrepareData();
    onSQFTLoadImport(payload);
  }

  return (
    roomGroups
      ? (roomGroups.map((feature, index) => {
        const roomIndex = index + startIndex;
        const isActive = roomIndex === activeRoomIndex;
        const partName = feature.part.partName.toLowerCase().replace(/ /g,"_");

        return (
          <li key={"dropdown" + index + startIndex}
              data-index={roomIndex}
              onClick={() => handleCategoryClick(feature, roomIndex)}
              className={baseClass+"__dropdown-list-item roomGroup-item"
              + (isActive ? ` ${baseClass}__dropdown-list-item--active` : "")
              + ` ${baseClass}__dropdown-list-item--${partName}`}>
            <FeatureName feature={feature.part}/>
          </li>
        )
      })
      ) : null
  )
}

QuotesSwitcherListRoomGroups.propTypes = {
  startIndex: PropTypes.number.isRequired,
  baseClass: PropTypes.string.isRequired,
  handleDropDownClick: PropTypes.func.isRequired,
  prepareSQFTData: PropTypes.func.isRequired,
  saveSQFTData: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  quotes: store.quotesState.quotes,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
  qtActiveCategory: store.qtState.qtActiveCategory,
  activeTheme: store.serverState.activeTheme,
  visualizersLoadedLength: store.serverState.visualizersLoaded,
  fabricatorSettings: store.fabricatorState.settings,
  fabricatorData: store.fabricatorState,
  cartItems: store.cartState.cartItems,
  activeRoom: store.sqftMenuState.activeRoom,
  activeRoomId: store.sqftMenuState.activeRoomId,
  activeRoomType: store.sqftMenuState.activeRoomType,
  activeRoomIndex: store.sqftMenuState.activeRoomIndex,
})

const mapDispatchToProps = {
  setQtActiveCategory,
  changeActivePartRelatedItemIndex,
  setSQFTActiveRoomIndex,
  setSQFTActiveRoomType,
  setSQFTActiveRoomId,
  setQuotes,
  setActiveQuoteIndex,
  addToCart,
  setSqftFromFeature,
}

export default injectIntl (
  connect(mapStateToProps, mapDispatchToProps)(QuotesSwitcherListRoomGroups)
);
